import moment from "moment";
import { Field, reduxForm } from "redux-form";
import { Button, Input } from "expano-components";

import { Dashboard, Select, DatePicker } from "components";

import useUpdate from "hooks/useUpdate";

import channel_campaign_statuses_options from "utils/select_options/channel_campaign_statuses_options";
import channel_campaign_group_kind_options from "utils/select_options/channel_campaign_group_kind_options";
import channel_campaign_group_offers_export_type_options from "utils/select_options/channel_campaign_group_offers_export_type_options";

const InputField = (props) => <Input {...props} />;
const SelectField = (props) => <Select {...props} />;
const MultiSelectField = (props) => <Select isMulti {...props} />;
const DatePickerField = (props) => <DatePicker {...props} />;

const placement_ids_options = [
  { label: "Wyniki wyszukiwania", value: "listing" },
  { label: "Lewa kolumna", value: "leftpanel" },
  { label: "Strona produktu", value: "showitem" },
  { label: "Pozostałe miejsca emisji", value: "mainpage" },
  { label: "Sieć reklamowa - Google Ads", value: "google" },
];

const convertValues = (values) => {
  const data = { ...values };

  if (data.display_end_date) {
    data.display_end_date = moment(values.display_end_date).format(
      "DD-MM-YYYY",
    );
  }

  return data;
};

const BasicData = ({
  channel_campaign_group,
  channel_campaign_id,
  channel_id,
  refetch,
  initialValues,
  handleSubmit,
  change,
  pristine,
  invalid,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/channels/${channel_id}/channel_campaigns/${channel_campaign_id}/channel_campaign_groups/${channel_campaign_group?.id}`,
    onSuccess: refetch,
  });

  const onSubmit = (values) => update(convertValues(values));

  return (
    <>
      <Dashboard header={{ title: "Kampania", icon: "info" }}>
        <div className="dashboard__form">
          <Input
            label="Kategoria"
            disabled
            meta={{}}
            input={{
              name: "root_taxon_id",
              value: channel_campaign_group?.channel_campaign?.root_taxon?.id
                ? `${channel_campaign_group?.channel_campaign.root_taxon.name} [${channel_campaign_group?.channel_campaign.root_taxon.identifier}]`
                : "Brak",
            }}
          />
          <Input
            label="ID zewnętrzne"
            disabled
            meta={{}}
            input={{
              name: "external_id",
              value: channel_campaign_group?.channel_campaign?.external_id,
            }}
          />
        </div>
      </Dashboard>
      <Dashboard
        header={{ title: "Grupa kampanii", icon: "info" }}
        footer={
          <>
            <Button
              type="save"
              text={is_updating ? "Proszę czekać..." : "Zapisz"}
              disabled={pristine || invalid || is_updating}
              onClick={handleSubmit(onSubmit)}
            />
          </>
        }
      >
        <form
          className="dashboard__form"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          <Field
            name="offers_export_type"
            label="Typ exportu"
            component={SelectField}
            options={channel_campaign_group_offers_export_type_options}
            handleChange={(value) => change("offers_export_type", value)}
            defaultValue={channel_campaign_group_offers_export_type_options.find(
              ({ value }) => value === initialValues.offers_export_type,
            )}
          />
          <Field
            name="kind"
            label="Rodzaj"
            component={SelectField}
            options={channel_campaign_group_kind_options}
            handleChange={(value) => change("kind", value)}
            defaultValue={channel_campaign_group_kind_options.find(
              ({ value }) => value === initialValues.kind,
            )}
          />
          <Field name="name" label="Nazwa" component={InputField} type="text" />
          <Field
            name="status"
            label="Status"
            component={SelectField}
            options={channel_campaign_statuses_options}
            handleChange={(value) => change("status", value)}
            defaultValue={channel_campaign_statuses_options.find(
              ({ value }) => value === initialValues.status,
            )}
          />
          <Field
            name="sales_period_standard_cpc"
            label="Standardowa stawka CPC"
            component={InputField}
            type="number"
            placeholder=">0.65 <10"
          />
          <Field
            name="budget_daily_amount"
            label="Budżet dzienny "
            component={InputField}
            type="number"
          />
          <Field
            name="budget_total_amount"
            label="Budżet całkowity"
            component={InputField}
            type="number"
          />
          <Field
            name="placements"
            label="Miejsce emisji"
            component={MultiSelectField}
            options={placement_ids_options}
            handleChange={(values) => change("placements", values)}
            defaultValue={placement_ids_options.filter(({ value }) =>
              initialValues.placements?.includes(value),
            )}
          />
          <div className="row m-t-20">
            <div className="box-6">
              <Field
                min_date={new Date()}
                disabled
                name="display_start_date"
                label="Data rozpoczęcia emisji"
                component={DatePickerField}
                onChange={(date) => change("display_start_date", date)}
              />
            </div>
            <div className="box-6">
              <Field
                min_date={new Date()}
                name="display_end_date"
                label="Data zakończenia emisji"
                component={DatePickerField}
                onChange={(date) => change("display_end_date", date)}
              />
            </div>
          </div>
        </form>
      </Dashboard>
    </>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.kind) {
    errors.kind = "Rodzaj kampanii jest wymagany!";
  }
  if (!values.name) {
    errors.name = "Nazwa grupy kampanii jest wymagana!";
  }

  if (!values.status) {
    errors.status = "Status kampanii jest wymagany!";
  }

  if (!values.sales_period_standard_cpc) {
    errors.sales_period_standard_cpc = "Standardowa stawka CPC jest wymagana!";
  }

  if (!values.budget_daily_amount) {
    errors.budget_daily_amount = "Dzienny budżet jest wymagany!";
  }

  return errors;
};
export default reduxForm({
  form: "update-channel-campaign-group",
  enableReinitialize: true,
  validate,
})(BasicData);
